import { render, staticRenderFns } from "./rtc-stats-panel.vue?vue&type=template&id=8bf280fc&scoped=true&"
import script from "./rtc-stats-panel.vue?vue&type=script&lang=ts&"
export * from "./rtc-stats-panel.vue?vue&type=script&lang=ts&"
import style0 from "./rtc-stats-panel.vue?vue&type=style&index=0&id=8bf280fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf280fc",
  null
  
)

export default component.exports